module.exports = __webpack_public_path__ + "static/media/github-original.48456281.svg";